(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SupplierPanelController', SetupController);

    SetupController.$inject = ['CompanyCustom', '$location', '$scope', 'Principal', 'LoginService', '$state', 'CompanyInfoQuery', 'ServantCustom', '__config', '$localStorage', '$translate', '$translatePartialLoader'];

    function SetupController(CompanyCustom, $location, $scope, Principal, LoginService, $state, CompanyInfoQuery, ServantCustom, __config, $localStorage, $translate, $translatePartialLoader) {
        var vm = this;
        vm.collapseMenu = collapseMenu;
        vm.menuIcon = menuIcon;
        vm.account = null;
        vm.menuState = menuState;
        vm.menuWiden = false;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.guidTipsEnable = false;
        vm.goToCurrentServant = goToCurrentServant;
        vm.goto = goto;
        vm.canViewReport = true;
        vm.uncheck = uncheck;
        vm.init = init;
        var cckey = $location.search().cckey;
        // loadCompanyInfo();
        vm.isWorkSpace = false;
        ;
        vm.checkActivityType = checkActivityType;
        vm.__config = __config;
        vm.wedoMeetMode = false;
        vm.logoSource = "content/images/logo-4.png";
        vm.setServantTooltip = setServantTooltip;
        vm.appVersion = 'v2';

        vm.init();

        function init() {

            $translatePartialLoader.addPart('activityType');
            $translatePartialLoader = $translate.refresh();

            if (!cckey)
                loadCompanyInfo();

            vm.servantClass = "fa fa-address-card fa-fw";
            vm.servantTranslateFile = "supplierPanel.sideMenu.servantInfo";
            Principal.getCurrentCompanyFeatureList();

            if (vm.__config.appMode == 'event') {
                vm.wedoMeetMode = true;
                vm.logoSource = "content/images/wedomeet.png"
            }
            if (vm.__config.appName && vm.__config.appName == 'planovin') {
                vm.logoSource = "content/images/planovin-white-space.svg"
            }

        }

        function menuIcon(x) {
            x.classList.toggle("change");
        }

        function changeCurrentCompany() {
            if (cckey) {
                vm.company = null;
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {

                    loadCompanyInfo();

                });
            }

        }

        function collapseMenu() {

        }

        function loadCompanyInfo() {

            CompanyInfoQuery.getCurrentCompanyInfo().get(function (company) {
                if (company != null && company != undefined) {
                    vm.company = company;
                    if (vm.company && vm.company.keyUrl)
                        vm.websiteUrl = vm.company.keyUrl + '.reserweb.ir';
                    else
                        vm.websiteUrl = '----------------' + '.reserweb.ir';


                } else {
                    vm.websiteUrl = '----------------' + '.reserweb.ir';
                }
                checkActivityType();
                vm.appVersion = company.appVersion;
                if (vm.appVersion == 'v3') {
                    $state.go('supplierPanel-v2.dashboard');
                }
            })


        }

        vm.guidTipsConfig = [
            {
                type: "title",
                heading: "Welcome to the NG-Joyride demo",
                text: '<div class="row"><div id="title-text" class="col-md-12"><span class="main-text">Welcome to <strong>Ng Joyride Demo</strong></span><br><span>( This demo will walk you through the features of Ng-Joyride. )</span><br/><br/><span class="small"><em>This can have custom html too !!!</em></span></div></div>'

            }, {
                type: "element",
                selector: "#scheduleStartDate",
                heading: "Custom Title",
                text: "The demo finishes.Head over to github to learn more",
                placement: "bottom",
                scroll: false
            }

        ];


        function goToCurrentServant() {
            ServantCustom.findServantByCurrentUser().query().$promise.then(function (result) {

                $state.transitionTo('supplierPanel.companyServants.edit', {id: result.id});

            });

        }

        function goto(state) {
            $state.transitionTo('supplierPanel' + state);
        }

        function menuState() {
            vm.menuWiden = false;
        }

        function uncheck() {

            // if (vm.checked == event.target.value)
            vm.checked = false
        }

        function checkActivityType() {
            if (vm.company && vm.company.activityType == 'WORK_SPACE') {
                vm.isWorkSpace = true;
                vm.servantTranslateFile = "supplierPanel.sideMenu.workSpaceInfo";
                vm.servantClass = "fa fa-building fa-fw";
                return;
            }
            if (vm.company && vm.company.activityType) {
                setServantTooltip();
            }

            vm.isWorkSpace = false;


        }


        function setServantTooltip() {

            vm.servantTranslateFileOptions = "";
            if (vm.company && vm.company.activityType)
                vm.servantTranslateFileOptions = 'tikonApp.ActivityType.ActivityTypeServants.' + vm.company.activityType;
        }


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
    }
})();
